import { useState } from "react";
import {
  Button,
  Card,
  TextField,
  TextFieldInput,
  TextFieldLabel,
} from "@hireart/component-library";
import $ from "jquery";

import { validEmail } from "../../Common/helpers/validations";

import { FormError } from "./FormError";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetSuccess, setResetSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);

    return $.ajax({
      url: "/users/password",
      type: "POST",
      dataType: "json",
      data: { user: { email } },
    })
      .then(() => {
        setLoading(false);
        setResetSuccess(true);
        setError("");
      })
      .catch(({ responseText }) => {
        const {
          errors: { email: emailErrors },
        } = JSON.parse(responseText);
        const [errorMessage] = emailErrors;
        setLoading(false);
        setShowError(true);
        setError(
          errorMessage === "not found" ? "Email not found" : errorMessage
        );
      });
  };

  return (
    <Card className="rounded-0 border-0 px-24 py-32 sm:rounded-16 sm:border-1">
      <h2 className="headline-1 mb-24 text-center">
        {resetSuccess ? "Almost done..." : "Reset your password"}
      </h2>

      <FormError error={error} />

      {!resetSuccess && (
        <p>
          Enter the email address you use to log in and we&apos;ll send you
          instructions on how to reset your password.
        </p>
      )}

      {!resetSuccess ? (
        <form onSubmit={handleSubmit}>
          <div className="my-16">
            <TextField hasError={error.length > 0 && showError}>
              <TextFieldLabel htmlFor="email" isUnstyled>
                Email
              </TextFieldLabel>
              <TextFieldInput
                autoFocus
                id="email"
                name="email"
                onChange={(e) => {
                  setEmail(e.target.value);
                  setShowError(false);
                }}
                placeholder="Email"
                size="md"
                value={email}
              />
            </TextField>
          </div>

          <Button
            isLoading={loading}
            type="submit"
            isFullWidth
            isDisabled={!validEmail(email) || loading}
          >
            Reset my password
          </Button>
        </form>
      ) : (
        <p>
          If an account with that email exists you will receive a link to reset
          your password shortly.
        </p>
      )}
    </Card>
  );
};

export { ForgotPassword };
